import { objectValidation } from "@domains/utils/validation";
export var SalesMTFReportMapper = function (data) {
    var _a;
    var reportLst = {
        respDtm: "",
        mtfPledgeLst: [],
    };
    if (data && (data === null || data === void 0 ? void 0 : data.mtfPledgeLst) && ((_a = data === null || data === void 0 ? void 0 : data.mtfPledgeLst) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        reportLst.respDtm = data === null || data === void 0 ? void 0 : data.respDtm;
        reportLst.mtfPledgeLst = data.mtfPledgeLst.map(function (record) {
            return objectValidation({
                transactionDate: record.trxDate,
                accountCode: record.accountCode,
                clientName: record.acName,
                stockName: record.scripFullName,
                quantity: record.plQty,
                status: record.respStatus,
            });
        });
    }
    return reportLst;
};
